import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";
import Button from "./Button";

const Header = ({ currentLanguage }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const location = useLocation();

const primaryNavItems = [
  {
    name: currentLanguage === 'en' ? 'Dashboard' : 'لوحة التحكم',
    path: '/creator-dashboard',
    icon: 'LayoutDashboard',
  },
  {
    name: currentLanguage === 'en' ? 'Campaigns' : 'الحملات',
    path: '/brand-campaign-studio',
    icon: 'Megaphone',
  },
  {
    name: currentLanguage === 'en' ? 'Create' : 'إنشاء',
    path: '/content-creation-suite',
    icon: 'PenTool',
  },
  {
    name: currentLanguage === 'en' ? 'Analytics' : 'التحليلات',
    path: '/analytics-command-center',
    icon: 'BarChart3',
  },
  {
    name: currentLanguage === 'en' ? 'Community' : 'المجتمع',
    path: '/community-showcase',
    icon: 'Users',
  },
];

const secondaryNavItems = [
  {
    name: currentLanguage === 'en' ? 'Trust Hub' : 'مركز الثقة',
    path: '/trust-and-verification-hub',
    icon: 'Shield',
  },
  {
    name: currentLanguage === 'en' ? 'Settings' : 'الإعدادات',
    path: '/settings',
    icon: 'Settings',
  },
  {
    name: currentLanguage === 'en' ? 'Help' : 'المساعدة',
    path: '/help',
    icon: 'HelpCircle',
  },
];




  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsMoreMenuOpen(false);
  };

  const toggleMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMoreMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Logo */}
        <Link
          to="/homepage"
          className="flex items-center space-x-2 hover:opacity-80 transition-opacity duration-300"
          onClick={closeMobileMenu}
        >
          <div className="w-8 h-8 bg-gradient-cultural rounded-lg flex items-center justify-center">
            <Icon name="Bridge" size={20} color="white" />
          </div>
          <span className="text-xl font-bold text-gradient-primary">
            CreatorBridge
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-1">
          {primaryNavItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`gap-2 flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                isActivePath(item?.path)
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted"
              }`}
            >
              <Icon name={item?.icon} size={16} />
              <span>{item?.name}</span>
            </Link>
          ))}

          {/* More Menu */}
          <div className="relative">
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleMoreMenu}
              className={`flex items-center space-x-2 ${
                isMoreMenuOpen ? "bg-muted" : ""
              }`}
            >
              <Icon name="MoreHorizontal" size={16} />
              <span>More</span>
            </Button>

            {isMoreMenuOpen && (
              <div className="absolute right-0 top-full mt-1 w-48 bg-popover border border-border rounded-md shadow-elevated py-1 z-50">
                {secondaryNavItems?.map((item) => (
                  <Link
                    key={item?.path}
                    to={item?.path}
                    onClick={() => setIsMoreMenuOpen(false)}
                    className={`flex items-center space-x-2 px-3 py-2 text-sm transition-colors duration-200 ${
                      isActivePath(item?.path)
                        ? "bg-primary text-primary-foreground"
                        : "text-popover-foreground hover:bg-muted"
                    }`}
                  >
                    <Icon name={item?.icon} size={16} />
                    <span>{item?.name}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </nav>

        {/* User Actions */}
        <div className="hidden lg:flex items-center space-x-3">
          <Button variant="ghost" size="sm">
            <Icon name="Bell" size={16} />
          </Button>
          <Button variant="ghost" size="sm">
            <Icon name="MessageSquare" size={16} />
          </Button>
          <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
            <Icon
              name="User"
              size={16}
              color="var(--color-secondary-foreground)"
            />
          </div>
        </div>

        {/* Mobile Menu Button */}
        <Button
          variant="ghost"
          size="sm"
          className="lg:hidden"
          onClick={toggleMobileMenu}
        >
          <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={20} />
        </Button>
      </div>
      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-card border-b border-border">
          <div className="px-4 py-2 space-y-1">
            {primaryNavItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                onClick={closeMobileMenu}
                className={`flex items-center space-x-3 px-3 py-3 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActivePath(item?.path)
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                }`}
              >
                <Icon name={item?.icon} size={18} />
                <span>{item?.name}</span>
              </Link>
            ))}

            <div className="border-t border-border pt-2 mt-2">
              {secondaryNavItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-3 py-3 rounded-md text-sm font-medium transition-colors duration-200 ${
                    isActivePath(item?.path)
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:text-foreground hover:bg-muted"
                  }`}
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.name}</span>
                </Link>
              ))}
            </div>

            {/* Mobile User Actions */}
            <div className="border-t border-border pt-2 mt-2 flex items-center justify-around">
              <Button variant="ghost" size="sm" className="flex-1">
                <Icon name="Bell" size={18} />
                <span className="ml-2">Notifications</span>
              </Button>
              <Button variant="ghost" size="sm" className="flex-1">
                <Icon name="MessageSquare" size={18} />
                <span className="ml-2">Messages</span>
              </Button>
              <Button variant="ghost" size="sm" className="flex-1">
                <Icon name="User" size={18} />
                <span className="ml-2">Profile</span>
              </Button>
            </div>
          </div>
        </div>
      )}
      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden"
          onClick={closeMobileMenu}
        />
      )}
      {/* Overlay for more menu */}
      {isMoreMenuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsMoreMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
